export default __webpack_public_path__ + "static/media/include_17@3x.5a795819.jpg";